import angular from 'angular';

function SettingsOrganizationCtrl(sdkUtils, organizationService, managementUserService, sdkOrganizationService, userService, alertService, formHelpersService, mapperService, permissionService) {
  const vm = this;

  const currentUserOrganization = organizationService.getCurrentOrganization();

  vm.loading = false;
  vm.organizationForm = mapperService.mapOrganizationToUI(currentUserOrganization);
  vm.saveOrganization = _saveOrganization;
  vm.noPermission = !permissionService.canWriteOrganization(currentUserOrganization.id);

  // ----------------------- private helpers ----------------------- //

  function _saveOrganization(form, $event) {
    if (!form) throw new Error('form is required');
    if ($event) $event.preventDefault();

    if (!form.$valid) {
      return null;
    }

    vm.savingOrganization = true;

    const changedValues = formHelpersService.getChangedFormValues(form);

    const organizationData = mapperService.mapOrganizationToApi(changedValues);

    return sdkOrganizationService.updateById(vm.organizationForm.id, organizationData)
      .then(updatedOrganization => {
        alertService.success('Company saved.');

        updatedOrganization = mapperService.mapOrganizationToUI(updatedOrganization);

        angular.extend(vm.organizationForm, updatedOrganization);
      })
      .catch(response => {
        alertService.error(sdkUtils.getErrorFromResponse(response));
      })
      .finally(() => {
        form.$setUntouched(); //reset the form values
        vm.savingOrganization = false;
      });
  }
}

SettingsOrganizationCtrl.$inject = [
  'jsSdk.utils',
  'organizationService',
  'jsSdk.managementUser',
  'jsSdk.organization',
  'jsSdk.user',
  'alertService',
  'formHelpersService',
  'mapperService',
  'permissionService'
];

export default SettingsOrganizationCtrl;



// WEBPACK FOOTER //
// ./src/components/settingsOrganization/settingsOrganizationCtrl.js